import { useNavigate } from 'react-router-dom';
import styles from './Close.module.scss';

export default function Close({ to }) {

  const navigate = useNavigate();

  return (
    <div 
      className={styles.container} 
      onClick={event => navigate(to ?? -1)}
    >
      &times;
    </div>
  )
}